import fuzzysort from 'fuzzysort';

const GetSearchResults = (allItems, type, searchTerm, returnScore = false) => {
  let keys = [ 'title' ];
  let threshold = -5000;

  switch(type) {
    case 'post':
      keys = [ 'title', 'content' ]
      threshold = -1000000;
      allItems = allItems.map(item => ({...item, content: item.content?.replace(/<[^>]+>/ig,"")}))
      break;
    case 'product':
      keys = [ 'sku', 'title', 'description', 'tags' ]
      threshold = -100000;
      break;
    case 'string':
      keys = []
      break;
    default:
      keys = [ 'title' ]
  }

  let results = [];

  if(searchTerm && searchTerm.length >= 1) {
    if(type === 'product') {
      allItems = allItems.map(prod => {
        if(Array.isArray(prod.sku)) {
          const skuResults = fuzzysort.go(searchTerm, prod.sku);
          prod.sku = skuResults.total ? skuResults[0].target : '';
        }
        if(Array.isArray(prod.tags)) {
          const tagResults = fuzzysort.go(searchTerm, prod.tags);
          prod.tags = tagResults.total ? tagResults[0].target : '';
        }
        return prod;
      })
    }

    results = fuzzysort.go(searchTerm, allItems, {
      keys: keys,
      threshold: threshold,
    })
  }

  return returnScore ? results.map(result => ({score: result.score, obj: result.obj})) : results.map(result => result.obj);
}

export default GetSearchResults;
